<template>
  <div>
    <BasicSingleVideo :title="title" :videosrc="videosrc" :videoposter="videoposter" :videopostermob="videopostermob" :videofullsrc="videofullsrc" :maidiansuffix="maidiansuffix"></BasicSingleVideo>
  </div>
</template>
<script>
import BasicSingleVideo from '@/components/basic-single-video.vue'
export default {
  components: {
    BasicSingleVideo
  },
  data() {
    return {
      title:'全新E-GMP全球纯电平台',
      videosrc: 'https://img.kia.cn/content/videos/20231114/normal-video.mp4',
      videofullsrc:'https://img.kia.cn/content/videos/20231114/E-GMP-Full.mp4',
      videoposter: 'https://img.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/videoposter/cover1.png',
      videopostermob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev5/vehicle/videoposter/cover1mob.png',
      maidiansuffix:'ev5 E-GMP视频'
    }
  },
  methods: {

  },
  mounted() {

  }
}
</script>
<style lang="scss" scoped>

</style>
